import { render, staticRenderFns } from "./orgDetails.vue?vue&type=template&id=0c6673ac&scoped=true&"
import script from "./orgDetails.vue?vue&type=script&lang=js&"
export * from "./orgDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6673ac",
  null
  
)

export default component.exports